angular.module('tgaAdmin').directive('codeBlock', () => ({
  compile(element) {
    const rawHtml = element[0].innerHTML;
    const code = angular.element('<pre></pre>');
    code.text(rawHtml.trim().replace('!--', '').replace('--', ''));
    element.replaceWith(code);
  },
}));
